import { useEffect } from 'react';
import { setSessionStorage } from '../helpers/common';

const useStoreUtmParams = () => {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const utmParams = {};
    for (const item of ['utm_source', 'utm_medium', 'utm_campaign']) {
      if (searchParams.has(item)) {
        const val = searchParams.get(item);
        if (val) {
          utmParams[item] = encodeURIComponent(val);
        }
      }
    }
    Object.keys(utmParams).length && setSessionStorage('utm_params', utmParams);
  }, []);
};

export default useStoreUtmParams;
